import { VideoToolbarProps } from './Types'
import { track } from '@tldraw/tldraw'
import { Toolbar } from '../ContextToolbar/Toolbar'
import { DeleteButton } from '../components/DeleteButton/DeleteButton'
import { VideoShape } from 'components/VisualStudioPlayground/Shapes/VideoShape/Types'
import { FitButton } from './components/FitButton'
import { FillButton } from './components/FillButton'
import { MoreOptionsButton } from '../components/MoreOptionsButton/MoreOptionsButton'

const VideoToolbar = track(({ editor, shapeId }: VideoToolbarProps) => {
  const shape = editor.getShape<VideoShape>(shapeId) as VideoShape

  return (
    <Toolbar>
      <FitButton editor={editor} selectedShape={shape} />
      <FillButton editor={editor} selectedShape={shape} />
      <DeleteButton />
      <MoreOptionsButton selectedShape={shape} />
    </Toolbar>
  )
})

export { VideoToolbar }
